import surveyDetailsLocale from './en.json'

const en = {
  surveyDetails: surveyDetailsLocale,
}

export default en
